import React from 'react';
import { InfoIcon } from 'lucide-react';
export function LegalNotice() {
  return <section aria-labelledby="aviso-importante" className="mx-auto w-full max-w-4xl px-4 pb-12 pt-4 sm:px-6 lg:px-8" data-id="element-223" data-mp="1djl4gpkzuyow">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 md:p-7" data-id="element-224" data-mp="1ii4sqwn28mkf">
        <h2 id="aviso-importante" className="mb-3 flex items-center gap-2 text-xs font-bold tracking-[.18em] text-blue-900 md:text-sm" data-id="element-225" data-mp="1nhhhjmxhs3pn">
          <InfoIcon className="h-4 w-4 text-amber-700" data-id="element-226" data-mp="1sfso9oshpy3n" />
          IMPORTANT NOTICE
        </h2>
        <div className="space-y-3 text-[13px] leading-relaxed text-slate-700 md:text-sm" data-id="element-227" data-mp="1whe1jb8xseed">
          <p data-id="element-228" data-mp="218w3o2mp4l0x">
            BIODECODING PRACTITIONER KIT™ is an educational digital resource for practitioners and facilitators.
          </p>
          <p data-id="element-229" data-mp="26ad09ly5dlbp">
            Its content and tools are intended for organisation, reflection, communication, and professional support
            within the user’s own scope of practice. It is not medical, psychological, psychiatric, legal, or
            emergency-care advice. It does not diagnose, treat, cure, or prevent any condition, and it does not
            replace qualified healthcare or mental-health support.
          </p>
          <p data-id="element-230" data-mp="1ajzsplfa17ex">
            For physical symptoms, urgent concerns, risk situations, or mental-health needs, users and clients should
            seek assistance from appropriately qualified local professionals or emergency services.
          </p>
        </div>
      </div>
    </section>;
}